import React from 'react'
import {
  Progress,
  Typography,
  Popconfirm,
  Button
} from 'antd'

/**
 *
 * @param {{
 *  uploadingFile: string,
 *  progress: number,
 *  cancelled?: boolean,
 *  onConfirmCancel?(): void
 * }} props
 * @returns
 */
export function FilesUploadProgress(props) {
  const watingForCancel = props.cancelled ?
    '- Cancelado al finalizar archivo actual' :
    ''

  return <div style={{ display: 'flex', alignItems: 'center' }}>
    <div style={{ paddingRight: 15, flex: 1 }}>
      <Typography.Text>{props.uploadingFile + ' ' + watingForCancel}</Typography.Text>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Progress
          percent={props.progress}
          size='small'
          status={props.progress < 100 ? 'active' : 'success'}
        />

        {props.cancelled === false &&
          <Popconfirm
            title='¿Cancelar operación?'
            onConfirm={props.onConfirmCancel}>
            <Button
              size='small'
              type='danger'
              shape='circle'
              icon='close' />
          </Popconfirm>
        }
      </div>
    </div>
  </div>
}
